import { parsePhoneNumberWithError } from "libphonenumber-js";

export const isValidEmail = (email: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
export const isValidUscCustomerId = (uscCustomerId: string) =>
  /^[0-9]{8,10}$/.test(uscCustomerId);

/**
 * We only test that the length is reasonable.
 * Additionally, we also ensure that a German phone number does not also include the local 0-prefix (so no 490<number>)
 * @param phone
 */
export const isValidPhone = (phone: string) => {
  if (phone.length > 9) {
    const phoneNumber = parsePhoneNumberWithError(phone);

    // Validate German numbers (due to incosistency in the lib)
    if (phoneNumber.country === "DE") {
      if (
        phoneNumber.nationalNumber.length >= 10 &&
        phoneNumber.nationalNumber.length <= 11
      ) {
        return phoneNumber.isValid();
      }
      return false;
    }
    return phoneNumber.isValid();
  }
  return false;
};
